import { Button, LinkButton } from '@yes.technology/react-toolkit'
import { AuthenticationType } from 'authentication/shared/types'
import jwtDecode from 'jwt-decode'
import { useTranslation } from 'react-i18n-lite'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getInitials } from 'shared/utils/string/userInitials'
import styled from 'styled-components'
import Avatar from '../Avatar/Avatar'
import usePostSignInUrl from '../Login/hooks/usePostSignInUrl'
import LogoArea from '../LogoArea'
import { Component } from '../ManagementDashboard'

export const AuthControlContainer = styled.div`
  margin-top: 12px;
  display: flex;
  gap: 12px;

  > :nth-child(2) {
    flex: 0 50%;
  }
`

export const PrivateContainer = styled.div`
  display: flex;
  gap: 12px;
  flex: 1;
`

type AuthControlProps = {
  login?: Component
  logoArea?: Component
  onAvatarClick: () => void
}

const AuthControl = ({ login, logoArea, onAvatarClick }: AuthControlProps) => {
  const { t } = useTranslation()

  const { token, tokenType } = useSelector(
    ({ authentication }: AuthenticationType) => authentication
  )

  const destinationUrl = usePostSignInUrl()

  if (!login && !logoArea) {
    return null
  }

  const { name, username, email } =
    (token &&
      jwtDecode<{
        name?: string
        username?: string
        email?: string
      }>(token)) ||
    {}

  const user = name || username || email
  const isLogged = token && tokenType === 'private'

  return (
    <AuthControlContainer>
      {(isLogged || logoArea) && (
        <PrivateContainer>
          {login && isLogged && (
            <Avatar
              initials={getInitials(user || 'Yes')}
              title={user}
              onClick={onAvatarClick}
            />
          )}
          {logoArea && <LogoArea {...logoArea} />}
        </PrivateContainer>
      )}
      {login && !isLogged && (
        <LinkButton role='button' heightClass='semiSmall' href={destinationUrl}>
          {t('login.button.des')}
        </LinkButton>
      )}

      {login && isLogged && (
        <Link to='/logout'>
          <Button heightClass='semiSmall'>{t('topline.logout')}</Button>
        </Link>
      )}
    </AuthControlContainer>
  )
}

export default AuthControl
